import { _findDate, _getEvents } from "../../controllers";

import { EVENTS } from '../actionTypes';
import dayjs from 'dayjs';
import { getAGMEGMData, getBoardMeetingsData, getBonusData, getBookClosure, getBuyBack, getDividentData, getRightsData, getSpiltstData } from '../../apis/cds';
import { deepClone } from '../../utils/global_functions';
import { LOCATIONS } from "../../utils/global_variables";



export const event = (startDate, endDate, exhcangeType, jtenantToken, currentDate, location) => async (dispatch, getState) => {
    const holdingsScrips = deepClone(getState().holdings?.holdingsScrips);
    dispatch(eventPending(true));
    const objResp = await _getEvents(startDate, endDate, exhcangeType, jtenantToken);
    if (objResp?.status) {
        dispatch(eventPending(false));
        const eventData = objResp.data[0].data.filter(event =>
            holdingsScrips?.find(holding => holding?.sSymbol === event?.title)
        ) || [];
        const selectedDate = _findDate(location === LOCATIONS.PORTFOLIO ? eventData : objResp.data[0].data, currentDate);
        dispatch(updateEventDate(selectedDate));
        dispatch(eventSuccess(objResp.data));

    } else {
        dispatch(eventPending(false));
        dispatch(eventFailure([]));
    }
    return Promise.resolve(objResp.data);
};

export const eventPending = (payload) => {
    return { type: EVENTS.GET_EVENT_PENDING_STATUS, payload };
};


export const eventSuccess = (payload) => {
    return { type: EVENTS.GET_EVENTS_SUCCESS, payload };
};

export const eventFailure = (payload) => {
    return { type: EVENTS.GET_EVENTS_FAILURE, payload };
};

export const updateActiveEvent = (activeEvent) => async (dispatch) => {
    dispatch(updateActiveEventSuccess(activeEvent));
};

export const updateActiveEventSuccess = (payload) => {
    return { type: EVENTS.UPDATE_ACTIVE_EVENT_TAB, payload };
};

export const updateEventDate = (selectedDate) => async (dispatch) => {
    dispatch(updateEventDateSuccess(selectedDate));
};

export const clearEventsState = () => async (dispatch) => {
    dispatch(clearEventsStateSuccess());
};

export const clearEventsStateSuccess = (payload) => {
    return { type: EVENTS.CLEAR_EVENTS_STATES, payload };
};

export const updateEventDateSuccess = (payload) => {
    return { type: EVENTS.UPDATE_EVENT_DATE, payload };
};


export const updateEventsSearchText = (searchText) => (dispatch) => {
    dispatch(updateEventsSearchTextSuccess(searchText));
};

export const updateEventsSearchTextSuccess = (activeTab) => {
    return { type: EVENTS.UPDATE_EVENTS_SEARCH_TEXT, payload: activeTab };
};


export const setDefaultEventsState = () => async (dispatch) => {
    dispatch(eventSuccess([]));
    dispatch(updateEventDate(dayjs()?.format('DD-MMM-YYYY')));
    dispatch(updateActiveEvent('ALL'));
    dispatch(updateEventsSearchText(''));
};

//MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info-events - Start

export const boardMeeting = (sExchange, sToken, sFromDate, sToDate, nPage, nPagesize, jtenantToken) => async (dispatch) => {
    dispatch(upadeteCorporateActionPendingStatus(true));
    const objResp = await getBoardMeetingsData({ exchange: sExchange, token: sToken, fromDate: sFromDate, toDate: sToDate, page: nPage, pagesize: nPagesize, jtenantToken: jtenantToken });
    if (objResp?.status) {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(boardMeetingSuccess(objResp?.data?.ResponseObject?.resultset));
        return Promise?.resolve(objResp);
    } else {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(boardMeetingFailure([]));
        return [];
    }
};

export const boardMeetingSuccess = (payload) => {
    return { type: EVENTS.GET_BOARD_MEETING_SUCCESS, payload };
};

export const boardMeetingFailure = (payload) => {
    return { type: EVENTS.GET_BOARD_MEETING_FAILURE, payload };
};

export const bookClosure = (sExchange, sToken, jtenantToken) => async (dispatch) => {
    dispatch(upadeteCorporateActionPendingStatus(true));
    const objResp = await getBookClosure({ exchange: sExchange, token: sToken, jtenantToken: jtenantToken });
    if (objResp?.status) {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(bookClosureSuccess(objResp?.data?.ResponseObject?.resultset));
        return Promise?.resolve(objResp);
    } else {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(bookClosureFailure([]));
    }
};

export const bookClosureSuccess = (payload) => {
    return { type: EVENTS.GET_BOOK_CLOSURE_SUCCESS, payload };
};

export const bookClosureFailure = (payload) => {
    return { type: EVENTS.GET_BOOK_CLOSURE_FAILURE, payload };
};

export const getAgmEgmData = (sExchange, sToken, mode, sFromDate, sToDate, nPage, nPagesize, jtenantToken) => async (dispatch) => {
    dispatch(upadeteCorporateActionPendingStatus(true));
    const objResp = await getAGMEGMData({ exchange: sExchange, token: sToken, mode: mode, fromDate: sFromDate, toDate: sToDate, page: nPage, pagesize: nPagesize, jtenantToken: jtenantToken });
    if (objResp?.status) {
        dispatch(upadeteCorporateActionPendingStatus(false));
        if (mode === 'AGM') {
            dispatch(getAgmDataSuccess(objResp?.data?.ResponseObject?.resultset));
        } else {
            dispatch(getEgmDataSuccess(objResp?.data?.ResponseObject?.resultset));
        }
        return Promise?.resolve(objResp);
    } else {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(getAgmDataFailure([]));
        dispatch(getEgmDataFailure([]));
    }
};

export const getAgmDataSuccess = (payload) => {
    return { type: EVENTS.GET_AGM_SUCCESS, payload };
};

export const getAgmDataFailure = (payload) => {
    return { type: EVENTS.GET_AGM_FAILURE, payload };
};

export const getEgmDataSuccess = (payload) => {
    return { type: EVENTS.GET_EGM_SUCCESS, payload };
};

export const getEgmDataFailure = (payload) => {
    return { type: EVENTS.GET_EGM_FAILURE, payload };
};


export const splitData = (sExchange, sToken, recordSize, sFromDate, sToDate, nPage, nPagesize, jtenantToken) => async (dispatch) => {
    dispatch(upadeteCorporateActionPendingStatus(true));
    const objResp = await getSpiltstData({ exchange: sExchange, token: sToken, recordSize: recordSize, fromDate: sFromDate, toDate: sToDate, page: nPage, pagesize: nPagesize, jtenantToken: jtenantToken });
    if (objResp?.status) {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(splitDataSuccess(objResp?.data?.ResponseObject?.resultset));
    } else {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(splitDataFailure([]));
    }
};

export const splitDataSuccess = (payload) => {
    return { type: EVENTS.GET_SPLITS_DATA_SUCCESS, payload };
};

export const splitDataFailure = (payload) => {
    return { type: EVENTS.GET_SPLITS_DATA_FAILURE, payload };
};


export const dividendData = (sExchange, sToken, recordSize, sFromDate, sToDate, nPage, nPagesize, jtenantToken) => async (dispatch) => {
    dispatch(upadeteCorporateActionPendingStatus(true));
    const objResp = await getDividentData({ exchange: sExchange, token: sToken, recordSize: recordSize, fromDate: sFromDate, toDate: sToDate, page: nPage, pagesize: nPagesize, jtenantToken: jtenantToken });
    if (objResp?.status) {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(dividendDataSuccess(objResp?.data?.ResponseObject?.resultset));
        return Promise?.resolve(objResp);
    } else {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(dividendDataFailure([]));
    }
};

export const dividendDataSuccess = (payload) => {
    return { type: EVENTS.GET_DIVIDEND_DATA_SUCCESS, payload };
};

export const dividendDataFailure = (payload) => {
    return { type: EVENTS.GET_DIVIDEND_DATA_FAILURE, payload };
};


export const buyBackData = (sExchange, sToken, jtenantToken) => async (dispatch) => {
    dispatch(upadeteCorporateActionPendingStatus(true));
    const objResp = await getBuyBack({ exchange: sExchange, token: sToken, jtenantToken: jtenantToken });
    if (objResp?.status) {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(buyBackDataSuccess(objResp?.data?.ResponseObject?.resultset));
        return Promise?.resolve(objResp);
    } else {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(buyBackDataFailure([]));
    }
};

export const buyBackDataSuccess = (payload) => {
    return { type: EVENTS.GET_BUY_BACK_SUCCESS, payload };
};

export const buyBackDataFailure = (payload) => {
    return { type: EVENTS.GET_BUY_BACK_FAILURE, payload };
};


export const rightsData = (sExchange, sToken, jtenantToken) => async (dispatch) => {
    dispatch(upadeteCorporateActionPendingStatus(true));
    const objResp = await getRightsData({ exchange: sExchange, token: sToken, jtenantToken: jtenantToken });
    if (objResp?.status) {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(rightsDataSuccess(objResp?.data?.ResponseObject?.resultset));
        return Promise?.resolve(objResp);
    } else {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(rightsDataFailure([]));
    }
};

export const rightsDataSuccess = (payload) => {
    return { type: EVENTS.GET_RIGHTS_DATA_SUCCESS, payload };
};

export const rightsDataFailure = (payload) => {
    return { type: EVENTS.GET_RIGHTS_DATA_FAILURE, payload };
};



export const bonusData = (sExchange, sToken, sFromDate, sToDate, nPage, recordSize, jtenantToken) => async (dispatch) => {
    dispatch(upadeteCorporateActionPendingStatus(true));
    const objResp = await getBonusData({ exchange: sExchange, token: sToken, fromDate: sFromDate, toDate: sToDate, recordSize: recordSize, jtenantToken: jtenantToken });
    if (objResp?.status) {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(bonusDataSuccess(objResp?.data?.ResponseObject?.resultset));
    } else {
        dispatch(upadeteCorporateActionPendingStatus(false));
        dispatch(bonusDataFailure([]));
    }
};

export const bonusDataSuccess = (payload) => {
    return { type: EVENTS.GET_BONUS_DATA_SUCCESS, payload };
};

export const bonusDataFailure = (payload) => {
    return { type: EVENTS.GET_BONUS_DATA_FAILURE, payload };
};


export const upadeteCorporateActionPendingStatus = (payload) => {
    return { type: EVENTS.IS_CORPORATE_ACTION_PENDING, payload };
};

//MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info-events - End


export const updateDetailedEvent = (payload) => {
    return { type: EVENTS.UPDATE_EVENT_DETAILS, payload };
};